import {
  Button,
  ImageLargePreview,
  Input,
  modalHandler,
  success,
  SwitchInput,
  useCustomForm,
  useEffect,
  useState,
} from "@";
import { saveContactMessage } from "../utils/api";
import { defaultValues, schema } from "../utils/validation";

const Show = ({ setData, values }) => {
  const [imagePreview, setImagePreview] = useState("");

  const {
    watch,
    setValue,
    reset,
    errors,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  // Function to handle form submission
  const submit = async (form) => {
    try {
      await saveContactMessage(form);
      success("تم الحفظ بنجاح");
      setData((prevData) =>
        prevData.map((item) => (item.id === form.id ? form : item)),
      );
      modalHandler();
    } catch (error) {}
  };

  // Reset form values on component mount or when values change
  useEffect(() => {
    reset(values);
  }, [values]);

  return (
    <>
      {/* Image preview popup */}
      <ImageLargePreview
        image={imagePreview}
        url={imagePreview}
        hide={() => setImagePreview("")}
      />
      <form onSubmit={handleSubmit(submit)} className="relative p-2 md:p-5">
        <div className="mb-5 grid gap-5 md:grid-cols-3">
          <Input
            star
            disabled
            label="الجوال"
            error={errors.phoneNumber}
            input={register("phoneNumber")}
          />

          <Input
            star
            disabled
            type="select"
            value={watch("type")}
            noEmptyOption
            label="نوع الرسالة"
            error={errors.type}
            input={register("type")}
          >
            <option value={0}>شكوي</option>
            <option value={1}>مقترح</option>
          </Input>
          <Input
            star
            disabled
            label="عنوان الرسالة"
            error={errors.messageTitle}
            input={register("messageTitle")}
          />
        </div>

        <div className="mb-5 grid gap-5 md:grid-cols-2">
          <Input
            star
            disabled
            type="textarea"
            label="محتوى الرسالة"
            error={errors.description}
            input={register("description")}
          />

          <Input
            type="textarea"
            error={errors.reply}
            label="رد على الرسالة"
            input={register("reply")}
            disabled={values?.contactUsReplyStatus}
          />
        </div>

        {!values?.contactUsReplyStatus && (
          <div className="mb-5">
            <SwitchInput
              label=" ارسال رسالة للمتبرع بوجود رد"
              checked={watch("sendReplyToCustomer")}
              change={(value) => setValue("sendReplyToCustomer", value)}
            />

            <SwitchInput
              label="تغير الحالة الى مغلقة"
              checked={watch("contactUsReplyStatus")}
              change={(value) => setValue("contactUsReplyStatus", value)}
            />
          </div>
        )}

        <div>
          {watch("imageFullUrl") && (
            <img
              loading="lazy"
              className="w-60 cursor-zoom-in"
              src={watch("imageFullUrl")}
              alt={watch("messageTitle")}
            />
          )}
        </div>

        {!values?.contactUsReplyStatus && (
          <div className="mt-5">
            <Button
              isLoading={isSubmitting}
              type="submit"
              title="حفظ البيانات"
            />
          </div>
        )}
      </form>
    </>
  );
};

export default Show;
